import React from 'react';

interface AdminModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  /** Optional max width class (default: max-w-2xl). Use max-w-md for narrower forms. */
  maxWidth?: 'max-w-md' | 'max-w-lg' | 'max-w-xl' | 'max-w-2xl';
}

/**
 * Shared modal for admin create/edit forms.
 * Use for consistent overlay, layout, and scroll behavior.
 */
export const AdminModal: React.FC<AdminModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'max-w-2xl',
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="admin-modal-title"
    >
      <div
        className={`bg-white rounded-lg p-6 max-h-[90vh] overflow-y-auto w-full mx-4 ${maxWidth}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="admin-modal-title" className="text-xl font-bold text-gray-900 mb-4">
          {title}
        </h2>
        {children}
      </div>
    </div>
  );
};
